export default "__VITE_ASSET__CDPKygpF__"